export default {
    add_patient: "Пациентті қосу",
    add_task: "Тапсырманы қосу",
    calls: "Қоңыраулар",
    chat_panel: "Чаттар панелі",
    clinic_id: "Клиниканың Id",
    confirm: "Растау",
    expenses: "Шығындар",
    high: "Жоғары",
    low: "Төмен",
    medium: "Орташа",
    no_notifications: "Хабарламалар жоқ",
    read_all: "Барлығы оқылған",
    remove_confirmation: "Растаудан бас тарту",
    tasks: "Тапсырмалар"
}
